import React from 'react';
import { comparisonData } from '../data/mock';
import { Check, X, Circle } from 'lucide-react';

const ComparisonSection = () => {
  const getStatusIcon = (value) => {
    if (value.startsWith('◎')) {
      return <div className="flex items-center gap-2"><span className="w-6 h-6 bg-cyan-500/20 rounded-full flex items-center justify-center"><Check className="w-4 h-4 text-cyan-600" /></span><span className="text-cyan-600 text-sm">{value.slice(2)}</span></div>;
    }
    if (value.startsWith('○')) {
      return <div className="flex items-center gap-2"><span className="w-6 h-6 bg-slate-200 rounded-full flex items-center justify-center"><Circle className="w-3 h-3 text-slate-500" /></span><span className="text-slate-600 text-sm">{value.slice(2)}</span></div>;
    }
    if (value.startsWith('△')) {
      return <div className="flex items-center gap-2"><span className="w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center"><span className="text-amber-600 text-xs font-bold">△</span></span><span className="text-amber-600 text-sm">{value.slice(2)}</span></div>;
    }
    if (value.startsWith('×')) {
      return <div className="flex items-center gap-2"><span className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center"><X className="w-4 h-4 text-red-500" /></span><span className="text-red-500 text-sm">{value.slice(2)}</span></div>;
    }
    return <span className="text-slate-600 text-sm">{value}</span>;
  };

  return (
    <section id="comparison" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            他ツールとの違い
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            E-E-A-Tチェッカーが得意とする領域
          </p>
        </div>

        {/* Comparison Table */}
        <div className="overflow-x-auto">
          <div className="min-w-[800px]">
            {/* Table Header */}
            <div className="grid grid-cols-5 gap-4 mb-4">
              {comparisonData.headers.map((header, index) => (
                <div
                  key={index}
                  className={`p-4 rounded-xl text-center font-medium ${
                    index === 4
                      ? 'bg-cyan-50 border-2 border-cyan-500 text-cyan-700'
                      : index === 0
                      ? 'bg-transparent text-slate-500'
                      : 'bg-slate-100 text-slate-700'
                  }`}
                >
                  <span className="whitespace-pre-line text-sm">{header}</span>
                </div>
              ))}
            </div>

            {/* Table Rows */}
            <div className="space-y-2">
              {comparisonData.rows.map((row, rowIndex) => (
                <div
                  key={rowIndex}
                  className="grid grid-cols-5 gap-4 items-center"
                >
                  {/* Item name */}
                  <div className="p-4 bg-slate-50 rounded-xl">
                    <span className="text-slate-900 font-medium text-sm">
                      {row.item}
                    </span>
                  </div>

                  {/* Values */}
                  {row.values.map((value, valueIndex) => (
                    <div
                      key={valueIndex}
                      className={`p-4 rounded-xl ${
                        valueIndex === 3
                          ? 'bg-cyan-50 border border-cyan-200'
                          : 'bg-slate-50'
                      }`}
                    >
                      {getStatusIcon(value)}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Note */}
        <div className="mt-8 text-center">
          <p className="text-slate-500 text-sm">
            ※ 各ツールの特性に基づく一般的な比較です。実際の機能はサービスにより異なります。
          </p>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;